import { AnswerOption } from "./AnswerOption";

export type QuestionId = number;

export type Profiler = "beauty-profiler" | "fragrance-profiler";

export type SingleChoiceQuestion = {
  id: QuestionId;
  number: number;
  question: string;
  backgroundPath: string;
  options: AnswerOption[];
  type: "single-choice";
  profiler: Profiler;
  variant: "black" | "white";
};

export type SliderQuestion = {
  id: QuestionId;
  number: number;
  question: string;
  backgroundPath: string;
  options: AnswerOption[];
  minLabel: string;
  maxLabel: string;
  type: "slider";
  profiler: Profiler;
  variant: "black" | "white";
};

export const isSingleChoiceQuestion = (
  question: Question
): question is SingleChoiceQuestion => {
  return question.type === "single-choice";
};

export const isSliderQuestion = (
  question: Question
): question is SliderQuestion => {
  return question.type === "slider";
};

export type Question = SingleChoiceQuestion | SliderQuestion;

export type QuestionSet = QuestionId[];